<template>
  <b-row class="pl-2 pr-4">
    <b-col
      cols="12"
      class="d-flex align-items-center justify-content-between mb-5"
    >
      <PageTitle title="Ferramentas de análise" />
    </b-col>

    <b-col cols="12" class="mb-4">
      <b-row>
        <b-col cols="4" class="pr-1">
          <label>Tag manager id</label>
          <b-input
            type="text"
            class="form-control"
            v-model="fields.gtmId"
            placeholder="GTM-XXXXXX"
          />
        </b-col>
        <b-col>
          <label>Código de verificação (opcional)</label>
          <b-input-group
            :prepend-html="`<i class='fas fa-lock-open'></i>`"
            class="mb-2 mr-sm-2 mb-sm-0"
          >
            <b-input
              type="text"
              class="form-control"
              v-model="fields.gtmSiteVerification"
              placeholder="Código de verificação do site"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12" class="mb-4">
      <b-row>
        <b-col cols="4" class="pr-1">
          <label>App tag manager id</label>
          <b-input
            type="text"
            class="form-control"
            v-model="fields.appGtmId"
            placeholder="GTM-XXXXXX"
          />
        </b-col>
        <b-col>
          <label>Código de verificação do app (opcional)</label>
          <b-input-group
            :prepend-html="`<i class='fas fa-lock-open'></i>`"
            class="mb-2 mr-sm-2 mb-sm-0"
          >
            <b-input
              type="text"
              class="form-control"
              v-model="fields.appGtmSiteVerification"
              placeholder="Código de verificação do app"
            />
          </b-input-group>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <b-row>
        <b-col cols="6">
          <label>Hotjar tracking code</label>
          <b-input
            type="text"
            class="form-control"
            v-model="fields.hotjarTrackingCode"
            placeholder="Ex: 2032328"
          />
        </b-col>

        <b-col cols="6">
          <label>Navegg ID</label>
          <b-input
            type="text"
            class="form-control"
            v-model="fields.naveggId"
            placeholder="Ex: 75415"
          />
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12" class="text-center my-4" v-if="whatClerkPermission()">
      <b-button variant="success" @click="save" :disabled="loading">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';
import NamePermission from '@/enums/Clerk/NamePermission';
import TypePermission from '@/enums/Clerk/TypePermission';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';

export default {
  name: 'GoogleAnalytics',
  mixins: [makeToast],
  components: {
    PageTitle,
  },
  data() {
    return {
      fields: {
        gtmId: '',
        gtmSiteVerification: '',
        appGtmId: '',
        appGtmSiteVerification: '',
        hotjarTrackingCode: '',
        naveggId: null,
      },
      loading: false,
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  created() {
    this.listAnalytics();
  },
  methods: {
    async listAnalytics() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      try {
        const { data } = await shopkeeperAppApi.get(
          `/customization/analytics/${this.userTypeId()}`
        );

        if (!data.data) return;

        this.fields = data.data || {};
      } finally {
        this.$store.dispatch('endLoader');
        this.loading = false;
      }
    },
    async save() {
      const request = {
        construpUserId: this.userTypeId(),
       ...this.fields,
      };

      this.$store.dispatch('startLoader');
      this.loading = true;

      try {
        await shopkeeperAppApi.put(`/customization/analytics`, request);

        this.makeToast(
          'Sucesso',
          'Ferramentas de análise atualizadas com sucesso',
          'success'
        );
      } catch {
        this.makeToast(
          'Ops',
          'Houve um erro ao atualizar as ferramentas de análise',
          'danger'
        );
      } finally {
        this.$store.dispatch('endLoader');
        this.loading = false;
      }
    },
    userTypeId(){
      return this.$route.meta.userType == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.FERRAMENTAS_ANALISE);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    },
  },
};
</script>
